const settings = {
  BASE_URL: window.BASE_URL ? window.BASE_URL : 'http://localhost:1337' ,
};

export default settings;
